// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__f4+ay","work_filters":"_styles_work_filters__RmLpv"};